import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import SignUpModal from 'flarum/forum/components/SignUpModal';

export default function extendSignUpModal() {
  extend(SignUpModal.prototype, 'oninit', function (original) {
    // window.open('https://authserver.cjlu.edu.cn/retrieve-password/accountActivation/index.html#/', '_blank');
    // setTimeout(() => app.modal.close(), 50);
    // return false;
  });

  override(SignUpModal.prototype, 'title', function (original) {
    return '特邀注册';
  });

  // extend(SignUpModal.prototype, 'fields', function (items) {
  //   items.add(
  //     'invitation',
  //     <div className="Form-group">
  //       <input
  //         className="FormControl"
  //         name="invitation"
  //         type="text"
  //         placeholder="邀请码"
  //         aria-label="邀请码"
  //         bidi={this.invitation}
  //       />
  //     </div>,
  //     40
  //   );
  // });
}
